import React from 'react';
import styled from 'styled-components';
import Slider from 'react-slick';
import 'slick-carousel/slick/slick.css';

const QuotesCarouselWrapper = styled.div `
    width: 100%;
    margin: 0 auto;

    *:focus{
        outline: 0;
    }
`;

const Slide = styled.div `
    text-align: center;
`
const SlideTitle = styled.h3 `
    font-size: 35px;
    line-height: 1.3;
    font-weight: 700;
    margin: 0 auto 20px;
    color: ${p => p.quotesColor};

    @media (max-width: 600px){
        font-size: 4.5vw;
    }
`

const SlideSubtitle = styled.h4 `
    font-size: 20px;
    color: ${p => p.quotesAuthorColor};
    font-weight: normal;
    margin: 0 auto;

    @media (max-width: 600px){
        font-size: 4vw;
    }
`

const QuotesCarousel = ({
    quotesColor = '#FFF',
    quotesAuthorColor = '#FFF',
    quotes = []
}) => {
    let settings = {
        infinite: true,
        speed: 1000,
        slidesToShow: 1,
        slidesToScroll: 1,
        arrows: false,
        fade: true,
        autoplay: true,
        autoplaySpeed: 6000
    };

    return (
        <QuotesCarouselWrapper>			
			<Slider {...settings}>
                { quotes.map((quote,pos) => <Slide key={pos}>
                    <SlideTitle quotesColor={quotesColor}>“{quote.text}”</SlideTitle>
                    <SlideSubtitle quotesAuthorColor={quotesAuthorColor}>- {quote.author}</SlideSubtitle></Slide>)}			
			</Slider>
		</QuotesCarouselWrapper>
    );
};

export default QuotesCarousel;
